export default "__VITE_ASSET__CS4u0oAf__"